import React from 'react';

import { useTranslation, Trans } from "react-i18next";

import Fade from 'react-reveal/Fade'

import pc from '../../img/AboutUs/pc.webp';
import mob from '../../img/AboutUs/mob.webp';

import { Link } from "react-router-dom"

function Main () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto mt-[70px] md:mt-[200px]">
                <div className='relative xl:block hidden'>
                    <img src={pc} alt="" />
                    <Link to="/form" className='absolute top-[80px] right-[270px]'>
                        <div className="contactus mr-auto hover:scale-[1.1] transition-all">
                            <p className="montserrat font-[600] text-[14px] xl:text-[16px]">{t('CompositeReinforcement.5')}</p>
                        </div>
                    </Link>
                    <Fade left>
                        <div className='absolute left-0 bottom-[80px]'>
                            <p className='text-[#F26522] open-sans text-[28px] xl:text-[45px] leading-[1.4]'>{t('about.1')}</p>
                            <p className='text-[14px] xl:text-[16px] font-[300] open-sans text-[#F6F6F6] mt-[30px] xl:max-w-[525px]'>{t('about.2')}</p>
                            <p className='text-[14px] xl:text-[16px] font-[300] open-sans text-[#F6F6F6] mt-[15px] xl:max-w-[525px]'>{t('about.3')}</p>
                        </div>
                    </Fade>
                </div>
                <div className='flex flex-col sm:flex-row justify-between gap-[20px] xl:hidden'>
                    <img src={mob} alt="" className='mb-auto'/>
                    <div className='flex flex-col'>
                        <p className='text-[#F26522] open-sans text-[28px] xl:text-[45px] leading-[1.4]'>{t('about.1')}</p>
                        <p className='text-[14px] xl:text-[16px] font-[300] open-sans text-[#F6F6F6] mt-[15px] xl:max-w-[525px]'>{t('about.2')}</p>
                        <p className='text-[14px] xl:text-[16px] font-[300] open-sans text-[#F6F6F6] mt-[10px] xl:max-w-[525px]'>{t('about.3')}</p>
                        <a href="" className='mt-[30px]'>
                            <div className="contactus mr-auto hover:scale-[1.1] transition-all">
                                <p className="montserrat font-[600] text-[14px] xl:text-[16px]">{t('CompositeReinforcement.5')}</p>
                            </div>
                        </a>
                    </div>
                </div> 
            </div>
        </div>
    );
}

export default Main;